"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var client_1 = require("@apollo/client");
var use_pusher_1 = require("@harelpls/use-pusher");
var pusher_js_1 = __importDefault(require("pusher-js"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var AnimationsListenerCreator_1 = require("../../animations/AnimationsListenerCreator");
var GameContext_1 = require("../../GameProvider/GameContext");
var index_1 = require("../../index");
var gameMiddleware_1 = __importDefault(require("../../Store/gameMiddleware"));
var gameReducer_1 = __importDefault(require("../../Store/gameReducer"));
var apollo_client_1 = require("./apollo-client");
var GameClientAPI_1 = __importDefault(require("./GameClientAPI"));
var RemoteGameLoader_1 = __importDefault(require("./RemoteGameLoader"));
pusher_js_1.default.logToConsole = true;
pusher_js_1.default.Runtime.createXHR = function () {
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    return xhr;
};
var authEndpoint = index_1.PLATFORM_URI + ((_a = process.env.REACT_APP_PUSHER_ENDPOINT) !== null && _a !== void 0 ? _a : '/api/pusher/auth');
var clientKey = (_b = process.env.REACT_APP_PUSHER_KEY) !== null && _b !== void 0 ? _b : '747557f1e8edf7fc2816';
var cluster = (_c = process.env.REACT_APP_PUSHER_CLUSTER) !== null && _c !== void 0 ? _c : 'eu';
function RemoteGameProvider(_a) {
    var children = _a.children, gameId = _a.gameId;
    var context = (0, react_1.useContext)(GameContext_1.gameContext);
    var store = (0, react_1.useMemo)(function () { return createRemoteApiStore(context, gameId); }, []);
    return ((0, jsx_runtime_1.jsx)(client_1.ApolloProvider, __assign({ client: (0, apollo_client_1.getApolloClient)() }, { children: (0, jsx_runtime_1.jsx)(use_pusher_1.PusherProvider, __assign({ authEndpoint: authEndpoint, clientKey: clientKey, cluster: cluster }, { children: (0, jsx_runtime_1.jsxs)(react_redux_1.Provider, __assign({ store: store }, { children: [(0, jsx_runtime_1.jsx)(RemoteGameLoader_1.default, { gameId: gameId }), children] })) })) })));
}
exports.default = RemoteGameProvider;
function createRemoteApiStore(context, gameId) {
    var _a;
    var api = new GameClientAPI_1.default(gameId);
    var Rules = (_a = context.RulesView) !== null && _a !== void 0 ? _a : context.Rules;
    var reducer = (0, gameReducer_1.default)(Rules, context.animations);
    var store = (0, redux_1.createStore)(reducer, (0, redux_1.applyMiddleware)((0, gameMiddleware_1.default)(api, Rules)));
    store.subscribe((0, AnimationsListenerCreator_1.createAnimationsListener)(store));
    api.init(store.dispatch);
    return store;
}
//# sourceMappingURL=RemoteGameProvider.js.map